export default __webpack_public_path__ + "static/media/logo-with-name-black.3cc41e93.svg";